import React from 'react';
import PropTypes from 'prop-types';

import { path } from 'ramda';

const SelectionBox = ({ start, end }) => {
    const style = {
        left: path(['0'], start),
        top: path(['1'], start),
        width: path(['0'], end),
        height: path(['1'], end),
    };

    return (
        <div
            className="detection detection--selection -pointer-events--none -z-7"
            style={style}
        >
            <div className="detection-grid detection-grid--h" />
            <div className="detection-grid detection-grid--v" />
        </div>
    );
};

SelectionBox.propTypes = {
    start: PropTypes.array.isRequired,
    end: PropTypes.array.isRequired,
};

export default SelectionBox;
